export enum SortBy {
  newest = 'Newest',
  alphabetically = 'Alphabetically',
  cheapest = 'Cheapest',
}
